export var tableHeader = function tableHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5em',
    padding: '1.2em 2em',
    marginBottom: '1.5em',
    backgroundColor: theme.infoLight,
    border: "1px solid ".concat(theme.info),
    '& p': {
      margin: 0,
      fontSize: '1.25rem',
      color: theme.gray600,
      lineHeight: 1.5
    },
    '& .info-icon': {
      fontSize: '2rem',
      color: theme.info,
      flexShrink: 0
    }
  };
};
export var tableWrap = function tableWrap(theme) {
  return {
    overflowX: 'auto',
    marginBottom: '2.5em',
    border: "1px solid ".concat(theme.gray100)
  };
};
export var tableSectionTitle = function tableSectionTitle(theme) {
  return {
    padding: '1em 1.5em',
    backgroundColor: theme.gray50,
    borderBottom: "1px solid ".concat(theme.gray100),
    fontSize: '1.3rem',
    fontWeight: 600,
    color: theme.gray600,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    '& i': {
      fontSize: '1.5rem',
      color: theme.primary
    }
  };
};
export var reportTable = function reportTable(theme) {
  return {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '1.2rem',
    '& thead': {
      backgroundColor: theme.gray50,
      '& th': {
        padding: '0.8em 0.8em',
        fontWeight: 600,
        color: theme.gray400,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        borderBottom: "2px solid ".concat(theme.gray100)
      }
    },
    '& tbody': {
      '& tr': {
        borderBottom: "1px solid ".concat(theme.gray100),
        transition: 'background-color 0.15s ease',
        '&:last-of-type': {
          borderBottom: 'none'
        },
        '&:hover': {
          backgroundColor: theme.gray50
        }
      },
      '& td': {
        padding: '0.7em 0.8em',
        color: theme.gray700,
        whiteSpace: 'nowrap'
      }
    }
  };
};
export var emptyTable = function emptyTable(theme) {
  return {
    padding: '2em',
    textAlign: 'center',
    color: theme.gray400,
    fontSize: '1.25rem'
  };
};